'use strict';

import React from 'react'

import Layout from '@Layout/BackOffice'

import DataList from '@/DataList'

import _config from '@Config/Blog/legal_blog'

import _ from 'lodash'

let config = _.cloneDeep(_config);

config.filter_query =
{
	type: 'legal',
	sort: 'date DESC'
};

let app = window.app;

export default class AdminBlogsListPage extends React.Component
{
	componentWillMount ()
	{
		app.resetFunctions();
	}

	render ()
	{
		const component = this, props = this.props;

		let output =
		(
			<Layout history={ props.history } page_title={ config.title }>

				<div className="page-content">

					<div className="o-content">
						<DataList config={ config } history={ props.history } />
					</div>

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;
	}
}
